<template>
  <div>
    <el-form :model="user" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="头像" prop="head_img">
        <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="GLOBAL.BASE_URL+imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

      </el-form-item>
      <el-form-item label="姓名" prop="realname" >
        <el-input type="text" v-model="user.realname"  disabled></el-input>
      </el-form-item>
      <el-form-item label="学校" >
        <el-select v-model="user.school_id" placeholder="选择学校"  @change="handleDepart"  disabled>
          <el-option v-for="item in schools" :key="'school'+item.id" :label="item.school_name"  :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    <!--  <el-form-item label="学校" prop="school_name">
        <el-input type="text" v-model="user.school_name"></el-input>
      </el-form-item>-->
      <el-form-item label="院系" prop="departname">
        <!-- <el-input type="text" v-model="user.school_name"></el-input> -->
        <el-select v-model="user.depart_id" placeholder="请选择" @change="selectdepart"  disabled>
          <el-option v-for="item in depart" :key="item.id" :label="item.department_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专业" prop="major_name">
        <!-- <el-input type="text" v-model="user.major_name" disabled></el-input> -->
        <el-select v-model="user.major_id" placeholder="请选择"  @change="selectmajor"  disabled>
          <el-option v-for="item in major" :key="item.id" :label="item.major_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年级" prop="grade_name">
        <!-- <el-input type="text" v-model="user.grade_name" disabled></el-input> -->
        <el-select v-model="user.grade_id" placeholder="请选择" @change="selectgrade" disabled>
          <el-option v-for="item in grade" :key="item.id" :label="item.grade_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级" prop="class_name">
        <!-- <el-input type="text" v-model="user.class_name" disabled></el-input> -->
          <el-select v-model="user.class_id" placeholder="请选择" disabled>
          <el-option v-for="item in classlist" :key="item.id" :label="item.class_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学号" prop="student_no">
         <el-input type="text" v-model="user.student_no" disabled></el-input>
      </el-form-item>
      <el-form-item label="注册时间" prop="birthday">
       <el-input type="text" v-model="user.created_at" disabled></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
      <!--   <el-button @click="resetForm('ruleForm')">重置</el-button>-->
      </el-form-item>

    </el-form>

  </div>

</template>
<script>
export default {
  name: 'MyInfo',
  inject: ['reload'],
  data() {
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('真实姓名不能为空'));
      } else {
        callback();
      }
    };
    return {
      classlist:[],
      schools:[],
      grade:[],
      major:[],
      depart: [],
      departname: '',
      imageUrl: '',
      ruleForm: {
        realname: '',
      },
      rules: {
        realname: [
          { validator: validateUsername, trigger: 'blur' }
        ],
      },
      user: {},
      uploadUrl: this.GLOBAL.BASE_URL + '/api/common/upload_file'
    };
  },
  methods: {
    handleDepart(val){
      this.getdepart()
    },
    selectdepart(val){
       this.getmajor()
    },
     selectmajor(val){
       this.getgrade()
    },
     selectgrade(val){
        this.getclass()
    },
    //院系
    getdepart() {
      this.$http.depart({
        school_id: this.user.school_id
      }).then(res => {

        if (res.data != null) {
          this.depart = res.data
        }

      })
    },
    //专业
    getmajor() {
      this.$http.major({
         parent_id:0,
         depart_id:this.user.depart_id,

      }).then(res => {

        if (res.data != null) {
          this.major = res.data
        }

      })
    },
    //年级
    getgrade() {
      this.$http.grade({
        major_id:this.user.major_id,

      }).then(res => {

        if (res.data != null) {
          this.grade = res.data
        }

      })
    },
    //班级
   getclass() {
      this.$http.getclass({
        grade_id:this.user.grade_id,

      }).then(res => {

        if (res.data != null) {
          this.classlist = res.data
        }

      })
    },
    getUserInfo() {
      this.$http.getUserInfo({'id': this.$store.getters.getUserInfo.id}).then(res => {
        if (res.data != null) {
          this.user = res.data;
          this.imageUrl = res.data.head_img;
          this.handleSchool()
          this.getdepart()
          this.getmajor()
          this.getgrade()
          this.getclass()
        }else{
			 this.$message.error(res.message)
		}

      })
    },
    handleSchool() {
        this.$http.school().then(res => {
            this.schools = res.data;
        })
    },
    handleAvatarSuccess(res, file) {
      this.user.head_img = this.$Base64.decode(res.data);
      console.log(this.user)
      this.imageUrl = this.$Base64.decode(res.data);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.updateUserInfo(this.user).then(res => {
            if (res.code !== 0) {
              this.$store.commit('SetUserInfo', this.user);
              this.$message.success(res.message);
              this.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.error('服务器内部错误!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.getUserInfo();
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/USer/MyInfo.vue